<template>
  <div>
    <div id="gjs"></div>


    <div class="modal fade" ref="saveEmailTemplateModal" id="saveEmailTemplateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:720px!important">
        <div class="modal-content">
          <div class="modal-content">
            <input placeholder="Sablon Ismi" v-model="emailTemplateName" />
            <button type="button" @click="saveEmailTemplate()">Submit</button>
          </div>
        </div>
      </div>
    </div>
    <button id="createPdf" type="button" @click="createPdf()" style="visibility: hidden;"></button>
  </div>
</template>
<!-- <script src="https://cdn.ckeditor.com/4.21.0/standard-all/ckeditor.js"></script> -->
<script>

 const grapesjs = require("grapesjs"); // can be replaced with the es6 import if a transpiler like babel is used
//  require("grapesjs/dist/css/grapes.min.css");
//  require("grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.css");
//  require('grapesjs-preset-newsletter');
//  require('grapesjs-plugin-ckeditor');
 import axios from 'axios'
//  import grapesjs from 'grapesjs'
  import 'grapesjs/dist/css/grapes.min.css'

  import gjsPresetNewsletter from 'grapesjs-preset-newsletter'
  import 'grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.css'

  import gjsPluginCkeditor from 'grapesjs-plugin-ckeditor'

 import {mapState} from 'vuex'
 import {mapActions} from 'vuex'
 import {mapGetters} from 'vuex'

 export default {
   name: "emailTemplateEditor",
   data() {
     return {
       editor: null,
       emailTemplateName: '',
       emailTemplateId: this.$route.params.emailTemplateId
     };
   },
   computed: {
     ...mapState([
       'baseUrl'
     ])
   },
   methods: {
     saveEmailTemplate () {
       $('#saveEmailTemplateModal').modal('hide')
       axios({
         method:'POST',
         url:'/saveEmailTemplate',
         baseURL: this.baseUrl,
         data: {
           emailTemplateName: this.emailTemplateName,
           emailTemplateHtml: this.editor.runCommand('gjs-get-inlined-html'),
           emailTemplate: this.editor.getComponents(),
           emailTemplateStyle: this.editor.getStyle(),
           emailTemplateAsset: this.editor.AssetManager.getAll()
         },
         withCredentials:true
       }).catch(function (error) {
         alert("Kaydederken hata oldu")
         console.log(error);
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status.code==="0"){
           console.log("Islem basarili!")
         }else{
           alert("Kaydederken hata oldu")
           console.log(error);
         }
       })
     },
     getEmailTemplate () {
       if (this.emailTemplateId === 'new') {
         // this.editor.setComponents("")
         console.log('new template')
       } else {
         axios({
           method:'POST',
           url:'/getEmailTemplate',
           baseURL: this.baseUrl,
           data: {
             emailTemplateId: this.emailTemplateId
           },
           withCredentials:true
         }).then((res)=>{
           return res
         }).then((res)=>{
           if(res.data.status.code==="0"){
             this.editor.setComponents(res.data.content.email_template.content);

             if (res.data.content.email_template.hasOwnProperty('style')) {
               this.editor.setStyle(res.data.content.email_template.style);
             }
             this.emailTemplateName = res.data.content.email_template.name

             if (res.data.content.email_template.hasOwnProperty('asset')) {
               console.log(res.data.content.email_template.asset);
               this.editor.AssetManager.load({
	             assets: res.data.content.email_template.asset
               })
             }
           }else{
             this.$notify({
               group: 'foo',
               type: 'error',
               title: this.$ml.get('ERROR'),
               text: res.data.status.desc
             })
             // this.editor.setComponents("")
             console.log('new template')
           }
         })
       }
     },
     createPdf() {
       axios({
         method:'POST',
         url:'/createPdf',
         baseURL: this.baseUrl,
         data: {
           emailTemplateHtml: this.editor.runCommand('gjs-get-inlined-html'),
         },
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status === "OK"){
           console.log("Islem basarili!!!!")
           window.open(res.data.url, '_blank')
         }else{
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       }
     )}
   },
   mounted() {

    //  if (!CKEDITOR.plugins.get('contentParameterList')) {
    //    CKEDITOR.plugins.add(
    //      'contentParameterList',
    //      {
    //        requires : ['richcombo'], //, 'styles' ],
    //        init : function( editor )
    //        {
    //          var config = editor.config,
    //              lang = editor.lang.format;

    //          // Gets the list of tags from the settings.
    //          var tags = [
    //            ['p.name', 'Ürün Adı'],
    //            ['p.code', 'Ürün Kodu'],
    //            ['p.price', 'Ürün Fiyat'],
    //            ['p.num', 'Ürün Adet'],
    //            ['p.disc', 'Ürün İndirim'],
    //            ['p.vat', 'Ürün KDV'],
    //            ['p.otv', 'Ürün ÖTV'],
    //            ['p.totalPrice', 'Ürün Tutar'],
    //            ['p.finalPrice', 'Vergili Ürün Tutar'],
    //            ['taxAdministration', 'Vergi Dairesi'],
    //            ['taxNo', 'Vergi No'],
    //            ['billingAddress', 'Fatura Adresi'],
    //            ['shipmentAddress', 'Sevk Adresi'],
    //            ['customerName', 'Müşteri Adı'],
    //            ['customerOrganizationName', 'Firma Adı'],
    //            ['contactName', 'İlgili Kişi'],
    //            ['contactPhone', 'İlgili Kişi Telefon'],
    //            ['contactEmail', 'İlgili Kişi E-Posta'],
    //            ['offerReferenceNo', 'Referans No'],
    //            ['offerDate', 'Teklif Tarihi'],
    //            ['offerExpireDate', 'Son Geçerlilik Tarihi'],
    //            ['offererName', 'Teklifi Sunan İsim'],
    //            ['offererTitle', 'Teklifi Sunan Görev'],
    //            ['offererSignature', 'Teklifi Sunan İmza'],
    //            ['customerTitle', 'Müşteri Görev'],
    //            ['acceptanceDate', 'Kabul Tarihi'],
    //            ['customerSignature', 'Müşteri İmza'],
    //            ['totalPrice', 'Toplam Tutar'],
    //            ['totalDiscount', 'Toplam İndirim'],
    //            ['subTotal', 'Ara Toplam'],
    //            ['totalVat', 'Toplam KDV Tutarı'],
    //            ['totalOtv', 'Toplam ÖTV Tutar'],
    //            ['finalPrice', 'Genel Toplam'],
    //            ['emailHead', 'Başlangıç Metni'],
    //            ['emailFooter', 'Bitiş Metni'],
    //            ['termsOfCondition', 'Koşullar'],
    //            ['offerTitle', 'Teklif Başlığı']
    //          ];

    //          editor.ui.addRichCombo(
    //            'contentParameterList',
    //            {
    //              label : "İçerik Parametresi",
    //              title :"İçerik Parametresi",
    //              voiceLabel : "İçerik Parametresi",
    //              className : 'cke_format',
    //              multiSelect : false,

    //              panel :
    //         {
    //           css : [ config.contentsCss, CKEDITOR.getUrl( CKEDITOR.skin.getPath('editor') + 'editor.css' ) ],
    //           voiceLabel : lang.panelVoiceLabel
    //         },

    //              init : function()
    //              {
    //                this.startGroup( "İçerik Parametresi" );
    //                //this.add('value', 'drop_text', 'drop_label');
    //                for (var this_tag in tags){
    //                  this.add('{{' + tags[this_tag][0] + '}}', tags[this_tag][1], tags[this_tag][1]);
    //                }
    //              },

    //              onClick : function( value )
    //              {
    //                editor.focus();
    //                editor.fire( 'saveSnapshot' );
    //                editor.insertHtml(value);
    //                editor.fire( 'saveSnapshot' );

    //              },
    //              onRender: function(){
		// 		   editor.on('selectionChange', function(ev){
		// 		     this.setValue('');
		// 		   }, this);
		// 	     }
    //          });
    //        }
    //    });
    //  }

    // if (!CKEDITOR.plugins.get('contentParameterList')) {
    //     CKEDITOR.plugins.add('contentParameterList', {
    //       requires: ['richcombo'],
    //       init: function(editor) {
    //         var config = editor.config;
    //         var lang = editor.lang.format;

    //         var tags = [
    //           ['p.name', 'Ürün Adı'],
    //           ['p.code', 'Ürün Kodu'],
    //           ['p.price', 'Ürün Fiyat'],
    //           ['p.num', 'Ürün Adet'],
    //           ['p.disc', 'Ürün İndirim'],
    //           ['p.vat', 'Ürün KDV'],
    //           ['p.otv', 'Ürün ÖTV'],
    //           ['p.totalPrice', 'Ürün Tutar'],
    //           ['p.finalPrice', 'Vergili Ürün Tutar'],
    //           ['taxAdministration', 'Vergi Dairesi'],
    //           ['taxNo', 'Vergi No'],
    //           ['billingAddress', 'Fatura Adresi'],
    //           ['shipmentAddress', 'Sevk Adresi'],
    //           ['customerName', 'Müşteri Adı'],
    //           ['customerOrganizationName', 'Firma Adı'],
    //           ['contactName', 'İlgili Kişi'],
    //           ['contactPhone', 'İlgili Kişi Telefon'],
    //           ['contactEmail', 'İlgili Kişi E-Posta'],
    //           ['offerReferenceNo', 'Referans No'],
    //           ['offerDate', 'Teklif Tarihi'],
    //           ['offerExpireDate', 'Son Geçerlilik Tarihi'],
    //           ['offererName', 'Teklifi Sunan İsim'],
    //           ['offererTitle', 'Teklifi Sunan Görev'],
    //           ['offererSignature', 'Teklifi Sunan İmza'],
    //           ['customerTitle', 'Müşteri Görev'],
    //           ['acceptanceDate', 'Kabul Tarihi'],
    //           ['customerSignature', 'Müşteri İmza'],
    //           ['totalPrice', 'Toplam Tutar'],
    //           ['totalDiscount', 'Toplam İndirim'],
    //           ['subTotal', 'Ara Toplam'],
    //           ['totalVat', 'Toplam KDV Tutarı'],
    //           ['totalOtv', 'Toplam ÖTV Tutar'],
    //           ['finalPrice', 'Genel Toplam'],
    //           ['emailHead', 'Başlangıç Metni'],
    //           ['emailFooter', 'Bitiş Metni'],
    //           ['termsOfCondition', 'Koşullar'],
    //           ['offerTitle', 'Teklif Başlığı']
    //         ];

    //         editor.ui.addRichCombo('contentParameterList', {
    //           label: 'İçerik Parametresi',
    //           title: 'İçerik Parametresi',
    //           voiceLabel: 'İçerik Parametresi',
    //           className: 'cke_format',
    //           multiSelect: false,
    //           panel: {
    //             css: [
    //               config.contentsCss,
    //               CKEDITOR.getUrl(CKEDITOR.skin.getPath('editor') + 'editor.css')
    //             ],
    //             voiceLabel: lang.panelVoiceLabel
    //           },

    //           init: function() {
    //             this.startGroup('İçerik Parametresi');

    //             for (var i = 0; i < tags.length; i++) {
    //               this.add(
    //                 'param:' + tags[i][0],
    //                 tags[i][1],
    //                 tags[i][1]
    //               );
    //             }
    //           },

    //           onClick: function(value) {
    //             var realValue = value.replace('param:', '');
    //             editor.focus();
    //             editor.fire('saveSnapshot');
    //             editor.insertHtml('{{ ' + realValue + ' }}');
    //             editor.fire('saveSnapshot');
    //           },

    //           onRender: function() {
    //             editor.on('selectionChange', function() {
    //               try {
    //                 this.setValue('', 'İçerik Parametresi');
    //               } catch (e) {}
    //             }, this);
    //           }
    //         });
    //       }
    //     });
    //   }

    if (!CKEDITOR.plugins.get('contentParameterList')) {
        CKEDITOR.config.versionCheck = false;
        CKEDITOR.plugins.add('contentParameterList', {
          requires: ['richcombo'],
          init: function(editor) {
            var config = editor.config || {};
            var lang = editor.lang && editor.lang.format ? editor.lang.format : {};

            var tags = [
              ['p.name', 'Ürün Adı'],
              ['p.code', 'Ürün Kodu'],
              ['p.price', 'Ürün Fiyat'],
              ['p.num', 'Ürün Adet'],
              ['p.disc', 'Ürün İndirim'],
              ['p.vat', 'Ürün KDV'],
              ['p.otv', 'Ürün ÖTV'],
              ['p.totalPrice', 'Ürün Tutar'],
              ['p.finalPrice', 'Vergili Ürün Tutar'],
              ['taxAdministration', 'Vergi Dairesi'],
              ['taxNo', 'Vergi No'],
              ['billingAddress', 'Fatura Adresi'],
              ['shipmentAddress', 'Sevk Adresi'],
              ['customerName', 'Müşteri Adı'],
              ['customerOrganizationName', 'Firma Adı'],
              ['contactName', 'İlgili Kişi'],
              ['contactPhone', 'İlgili Kişi Telefon'],
              ['contactEmail', 'İlgili Kişi E-Posta'],
              ['offerReferenceNo', 'Referans No'],
              ['offerDate', 'Teklif Tarihi'],
              ['offerExpireDate', 'Son Geçerlilik Tarihi'],
              ['offererName', 'Teklifi Sunan İsim'],
              ['offererTitle', 'Teklifi Sunan Görev'],
              ['offererSignature', 'Teklifi Sunan İmza'],
              ['customerTitle', 'Müşteri Görev'],
              ['acceptanceDate', 'Kabul Tarihi'],
              ['customerSignature', 'Müşteri İmza'],
              ['totalPrice', 'Toplam Tutar'],
              ['totalDiscount', 'Toplam İndirim'],
              ['subTotal', 'Ara Toplam'],
              ['totalVat', 'Toplam KDV Tutarı'],
              ['totalOtv', 'Toplam ÖTV Tutar'],
              ['finalPrice', 'Genel Toplam'],
              ['emailHead', 'Başlangıç Metni'],
              ['emailFooter', 'Bitiş Metni'],
              ['termsOfCondition', 'Koşullar'],
              ['offerTitle', 'Teklif Başlığı'],
              ['companyPhone', 'Firma Telefon'],
              ['companyEmail', 'Firme E-Posta']
            ];

            var panelCss = [];
            if (Array.isArray(config.contentsCss)) {
              panelCss = config.contentsCss.slice();
            } else if (config.contentsCss) {
              panelCss = [config.contentsCss];
            }
            panelCss.push(
              CKEDITOR.getUrl(CKEDITOR.skin.getPath('editor') + 'editor.css')
            );

            editor.ui.addRichCombo('contentParameterList', {
              label: 'İçerik Parametresi',
              title: 'İçerik Parametresi',
              voiceLabel: 'İçerik Parametresi',
              className: 'cke_format',
              multiSelect: false,

              panel: {
                css: panelCss,
                voiceLabel: lang.panelVoiceLabel || 'İçerik Parametresi'
              },

              init: function() {
                this.startGroup('İçerik Parametresi');

                for (var i = 0; i < tags.length; i++) {
                  this.add(
                    'param:' + tags[i][0],
                    tags[i][1],
                    tags[i][1]
                  );
                }
              },

              onClick: function(value) {
                var realValue = String(value).replace('param:', '');
                editor.focus();
                editor.fire('saveSnapshot');
                editor.insertHtml('{{ ' + realValue + ' }}');
                editor.fire('saveSnapshot');
              }
            });
          }
        });
      }

     this.editor = grapesjs.init({
      container: '#gjs',
      plugins: [
        gjsPresetNewsletter,
        gjsPluginCkeditor
      ],
      pluginsOpts: {
        [gjsPresetNewsletter]: {
          modalLabelImport: 'Paste all your code here below and click import',
          modalLabelExport: 'Copy the code and use it wherever you want',
          codeViewerTheme: 'material',
          importPlaceholder: '<table class="table"><tr><td class="cell">Hello world!</td></tr></table>',
          cellStyle: {
            'font-size': '12px',
            'font-weight': 300,
            'vertical-align': 'top',
            color: 'rgb(111, 119, 125)',
            margin: 0,
            padding: 0,
          },
          categoryLabel: 'Default'
        },
        [gjsPluginCkeditor]: {
          position: 'center',
          options: {
            startupFocus: true,
            extraAllowedContent: '*(*);*{*}',
            allowedContent: true,
            extraPlugins: 'sharedspace,justify,colorbutton,panelbutton,font,contentParameterList',
            toolbar: [
              { name: 'styles', items: ['Font', 'FontSize', 'contentParameterList'] },
              ['Bold', 'Italic', 'Underline', 'Strike'],
              { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
              { name: 'links', items: ['Link', 'Unlink'] },
              { name: 'colors', items: ['TextColor', 'BGColor'] },
            ],
          }
        }
      }
    })

    //  this.editor = grapesjs.init({
    //    container: '#gjs',
    //    assetManager: {
    //      upload: 'https://live.minimumcrm.com/pc-api/storeImages',
    //      autoAdd: true,
    //      uploadName: 'files',
    //      assets: []
    //    },
    //    plugins: [
    //      'gjs-preset-newsletter', 'gjs-plugin-ckeditor'
    //    ],
    //    pluginsOpts: {
    //      'gjs-preset-newsletter': {
    //        modalLabelImport: 'Paste all your code here below and click import',
    //        modalLabelExport: 'Copy the code and use it wherever you want',
    //        codeViewerTheme: 'material',
    //        //defaultTemplate: templateImport,
    //        importPlaceholder: '<table class="table"><tr><td class="cell">Hello world!</td></tr></table>',
    //        cellStyle: {
    //          'font-size': '12px',
    //          'font-weight': 300,
    //          'vertical-align': 'top',
    //          color: 'rgb(111, 119, 125)',
    //          margin: 0,
    //          padding: 0,
    //        },
    //        categoryLabel: 'Default'
    //      },
    //      'gjs-plugin-ckeditor': {
    //        position: 'center',
    //        options: {
    //          startupFocus: true,
    //          extraAllowedContent: '*(*);*{*}', // Allows any class and any inline style
    //          allowedContent: true, // Disable auto-formatting, class removing, etc.
    //          // enterMode: CKEDITOR.ENTER_BR,
    //          extraPlugins: 'sharedspace,justify,colorbutton,panelbutton,font,contentParameterList',
    //          toolbar: [
    //            { name: 'styles', items: ['Font', 'FontSize', 'contentParameterList'] },
    //            ['Bold', 'Italic', 'Underline', 'Strike'],
    //            {name: 'paragraph', items : [ 'NumberedList', 'BulletedList']},
    //            {name: 'links', items: ['Link', 'Unlink']},
    //            {name: 'colors', items: [ 'TextColor', 'BGColor' ]},
    //          ],
    //        }
    //      }
    //    }
    //  })

     this.editor.DeviceManager.add({
       height: '100%',
       id: 'devicePdf',
       name: 'PDF',
       width: '1200px',
       widthMedia: '1200px', // the width that will be used for the CSS media
     });

     var saveBtn = this.editor.Panels.addButton('views',{
       id: 'savebtn',
       className: 'fa fa-floppy-o',
       command: 'saveCmd',
       attributes: { title: 'Şablonu Kaydet'},
       active: false,
     });

     var saveBtn = this.editor.Panels.addButton('views',{
       id: 'pdfbtn',
       className: 'fa fa-file-pdf-o',
       command: 'pdfCmd',
       attributes: { title: 'PDF Olustur'},
       active: false,
     });

     this.editor.BlockManager.add('sect8', {
       label: '1/8 Section',
       category: 'Default',
       attributes: {class:'gjs-fonts gjs-f-b3'},
       content: `<table style="box-sizing: border-box; height: 150px; margin: 0 auto 10px auto; padding: 5px 5px 5px 5px; width: 100%;" width="100%" height="150">
        <tr>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 14%"></td>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 25%"></td>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 12.5%"></td>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 6.25%"></td>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 6.25%"></td>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 6.25%"></td>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 6.25%"></td>
          <td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: top; color: rgb(111, 119, 125); margin: 0; padding: 0; width: 11%"></td>
        </tr>
        </table>`,
     });

     this.editor.BlockManager.add('logo_field_01', {
       label: 'Logo + Sağda Adres',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-logo-sagda-adres'},
       content: {
         style: {
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "type": "table",
         "attributes": {},
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {},
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {},
                     "style": {
                       "padding": "15px 0 0 20px",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {},
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {},
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {},
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong></span></span><br />\n<span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Efeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "right"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       },
     });

     this.editor.BlockManager.add('logo_field_02', {
       label: 'Logo + Sağda Adres',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-logo-sagda-adres'},
       content: {
         "type": "table",
         "attributes": {},
         "style": {
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {},
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {},
                     "style": {
                       "padding": "15px 0 0 20px",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "30px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong></span></span><br />\n<span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Efeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "right"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       },
     });

     this.editor.BlockManager.add('logo_field_03', {
       label: 'Logo + Sağda Başlık',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-logo-sagda-baslik'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "15px 0 0 20px",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong></span></span><br />\n<span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Efeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "left"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:48px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">TEKLİF</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "5px 10px 0 10px",
                           "color": "#353535",
                           "text-align": "right"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('logo_field_04', {
       label: 'Solda Başlık + Logo',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-solda-baslik-logo'},
       content:     {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:48px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">TEKLİF</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "5px 10px 0 10px",
                           "color": "#353535",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "15px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px",
                       "text-align": "right"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong><br />\nEfeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "right"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });


     this.editor.BlockManager.add('logo_field_05', {
       label: 'Logo Alanı + Adres',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-logo-alani-adres'},
       content:     {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "15px 0 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "15%",
                       "font-size": "12px",
                       "text-align": "center"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     }
                     ,
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:18px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong><br />\nEfeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "left"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });


     this.editor.BlockManager.add('logo_field_06', {
       label: 'Logo Alanı + Adres',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-logo-alani-adres-2'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "background-color": "#101233",
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 0 20px 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "15%",
                       "font-size": "12px",
                       "text-align": "center"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "border": "2px solid #ffffff",
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"color:#ffffff;\"><span style=\"font-size:18px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong><br />\nEfeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "15px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "left"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('logo_field_07', {
       label: 'Ortada Logo + Adres',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts  gjs-c gjs-c-ortada-logo-adres'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "15px 0 0 20px",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px",
                       "text-align": "center"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong></span></span><br />\n<span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Efeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "3px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('logo_field_08', {
       label: 'Ortada Logo + Adres',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-ortada-logo-adres-2'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "background-color": "#101233",
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "15px 0 0 20px",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 0 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px",
                       "text-align": "center"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://minimumcrm-email-templates.fra1.digitaloceanspaces.com/images/test-logo.jpeg",
                         },
                         "style": {
                           "border": "2px solid #ffffff",
                           "color": "black",
                           "width": "155px",
                           "en": "",
                           "height": "153px",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"color:#ffffff;\"><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong></span></span><br />\n<span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Efeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "3px 10px 10px 0",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('logo_field_09', {
       label: 'Solda Şirket Bilgileri',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-solda-sirket-bilgileri'},
       content:{
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 5px 5px 5px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "20%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:26px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Halkla İlişkiler ve Internet Hizmetleri Ltd. Şti.</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px 10px 0 20px",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"color:#7f8c8d;\"><span style=\"font-size:18px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Efeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 10px 10px 20px",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "left"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 20px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('logo_field_10', {
       label: 'Ortada Şirket Bilgileri',
       category: 'Logo Alanları',
       attributes: {class:'gjs-fonts gjs-c gjs-c-ortada-sirket-bilgileri'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "33.3333%",
                       "font-size": "12px",
                       "text-align": "center"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:26px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Internet Hizmetleri Ltd. Şti.</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px 10px 0 20px",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"color:#7f8c8d;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Efeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 10px 10px 20px",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "center"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('teklif_01', {
       label: 'Teklif Başlık 01',
       category: 'Teklif Başlık',
       attributes: {class:'gjs-fonts gjs-c gjs-c-teklif-baslik-01'},
       content:     {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "auto"
         },
         "components": [
           {
             "type": "tbody",
             "attributes": {
             },
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:24px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">TEKLİF</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "5px 10px 5px 10px",
                           "color": "#353535"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('teklif_02', {
       label: 'Teklif Başlık 02',
       category: 'Teklif Başlık',
       attributes: {class:'gjs-fonts gjs-c gjs-c-teklif-baslik-02'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "auto"
         },
         "components": [
           {
             "type": "tbody",
             "attributes": {
             },
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:36px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">TEKLİF</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "5px 10px 0 10px",
                           "color": "#353535",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "margin": "5px 0 10px 0",
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "attributes": {
                             },
                             "components": [
                               {
                                 "type": "row",
                                 "attributes": {
                                 },
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });


     this.editor.BlockManager.add('teklif_03', {
       label: 'Teklif Başlık 03',
       category: 'Teklif Başlık',
       attributes: {class:'gjs-fonts gjs-c gjs-c-teklif-baslik-03'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "auto"
         },
         "components": [
           {
             "type": "tbody",
             "attributes": {
             },
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:24px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">TEKLİF</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none rgb(170, 170, 170)",
                           "background-color": "#353535",
                           "padding": "5px 10px 5px 10px",
                           "color": "#ffffff",
                           "text-align": "center"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });


     this.editor.BlockManager.add('imza_01', {
       label: 'Imza Alanı - Zemin',
       category: 'Imza Alanı',
       attributes: {class:'gjs-fonts gjs-c gjs-c-imza-alani-zemin'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Teklifi Sunan</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#353535",
                           "__": 1,
                           "padding": "3px 10px 3px 10px",
                           "color": "#ffffff"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İsim: {{ offererName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#e8e8e8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">G&ouml;rev: {{ offererTitle }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#f8f8f8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tarih: {{ offerDate }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#e8e8e8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İmza: {{ offererSignature }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#f8f8f8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 50px 10px",
                           "color": "#212121"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Teklifi Kabul Eden</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#353535",
                           "__": 1,
                           "padding": "3px 10px 3px 10px",
                           "color": "#ffffff"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İsim: {{ customerName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#e8e8e8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">G&ouml;rev: {{ customerTitle }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#f8f8f8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tarih: {{ acceptanceDate }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#e8e8e8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İmza: {{ customerSignature }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#f8f8f8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 50px 10px",
                           "color": "#212121"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('imza_02', {
       label: 'Imza Alanı - Alt Çizgi',
       category: 'Imza Alanı',
       attributes: {class:'gjs-fonts gjs-c gjs-c-imza-alani-alt-cizgi'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0 10px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">TEKLİFİ SUNAN</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "3px 10px 0 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İsim:  {{ offererName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     },
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">G&ouml;rev: {{ offererTitle }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tarih: {{ offerDate }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İmza: {{ offererSignature }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "2px solid #212121",
                           "padding": "3px 10px 50px 10px",
                           "color": "#212121"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0 0 0 10px",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">TEKLİFİ KABUL EDEN</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "3px 10px 0 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İsim: {{ customerName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">G&ouml;rev: {{ customerTitle }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tarih: {{ acceptanceDate }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İmza: {{ customerSignature }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "2px solid #212121",
                           "padding": "3px 10px 50px 10px",
                           "color": "#212121"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });


     this.editor.BlockManager.add('firma_01', {
       label: 'Firma Bilgileri - Zemin',
       category: 'Firma Bilgileri',
       attributes: {class:'gjs-fonts gjs-c gjs-c-firma-bilgileri-zemin'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">M&uuml;şteri: {{ customerName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#f8f8f8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İlgili Kişi: {{ contactName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Telefon: {{ contactPhone }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#f8f8f8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">E-Posta: {{ contactEmail }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#e8e8e8",
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 5px 0 5px",
                           "margin": "0 auto 10px auto",
                           "width": "100%",
                           "height": "150px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "attributes": {
                                     },
                                     "style": {
                                       "padding": "0",
                                       "margin": "0",
                                       "color": "rgb(111, 119, 125)",
                                       "font-weight": "300",
                                       "vertical-align": "top",
                                       "width": "30%",
                                       "font-size": "12px"
                                     }
                                   },
                                   {
                                     "type": "cell",
                                     "attributes": {
                                     },
                                     "style": {
                                       "padding": "0",
                                       "margin": "0",
                                       "color": "rgb(111, 119, 125)",
                                       "font-weight": "300",
                                       "vertical-align": "top",
                                       "width": "70%",
                                       "font-size": "12px"
                                     },
                                     "components": [
                                       {
                                         "type": "text",
                                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Referans No: {{ offerReferenceNo }}</span></span></strong></p>\n",
                                         "attributes": {
                                         },
                                         "style": {
                                           "background-color": "#f8f8f8",
                                           "border": "1px solid #aaaaaa",
                                           "padding": "3px 10px 3px 10px",
                                           "color": "#212121"
                                         }
                                       },
                                       {
                                         "type": "text",
                                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tarih: {{ offerDate }}</span></span></strong></p>\n",
                                         "attributes": {
                                         },
                                         "style": {
                                           "background-color": "#e8e8e8",
                                           "border": "1px solid #aaaaaa",
                                           "padding": "3px 10px 3px 10px",
                                           "color": "#212121"
                                         }
                                       },
                                       {
                                         "type": "text",
                                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Son Ge&ccedil;erlilik: {{ offerExpireDate }}</span></span></strong></p>\n",
                                         "attributes": {
                                         },
                                         "style": {
                                           "background-color": "#f8f8f8",
                                           "border": "1px solid #aaaaaa",
                                           "padding": "3px 10px 3px 10px",
                                           "color": "#212121"
                                         }
                                       }
                                     ]
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });


     this.editor.BlockManager.add('firma_02', {
       label: 'Firma Bilgileri - Alt Çizgi',
       category: 'Firma Bilgileri',
       attributes: {class:'gjs-fonts gjs-c gjs-c-firma-bilgileri-alt-cizgi'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">M&uuml;şteri: {{ customerName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İlgili Kişi: {{ contactName }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Telefon: {{ contactPhone }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">E-Posta: {{ contactEmail }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 5px 0 5px",
                           "margin": "0 auto 10px auto",
                           "width": "100%",
                           "height": "150px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "attributes": {
                                     },
                                     "style": {
                                       "padding": "0",
                                       "margin": "0",
                                       "color": "rgb(111, 119, 125)",
                                       "font-weight": "300",
                                       "vertical-align": "top",
                                       "width": "30%",
                                       "font-size": "12px"
                                     }
                                   },
                                   {
                                     "type": "cell",
                                     "attributes": {
                                     },
                                     "style": {
                                       "padding": "0",
                                       "margin": "0",
                                       "color": "rgb(111, 119, 125)",
                                       "font-weight": "300",
                                       "vertical-align": "top",
                                       "width": "70%",
                                       "font-size": "12px"
                                     },
                                     "components": [
                                       {
                                         "type": "text",
                                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Referans No: {{ offerReferenceNo }}</span></span></strong></p>\n",
                                         "attributes": {
                                         },
                                         "style": {
                                           "border": "none #aaaaaa",
                                           "background-color": "none",
                                           "padding": "3px 10px 0 10px",
                                           "color": "#212121"
                                         }
                                       },
                                       {
                                         "type": "table",
                                         "attributes": {
                                         },
                                         "style": {
                                           "width": "100%",
                                           "margin-top": "10px",
                                           "margin-bottom": "10px"
                                         },
                                         "components": [
                                           {
                                             "type": "tbody",
                                             "components": [
                                               {
                                                 "type": "row",
                                                 "components": [
                                                   {
                                                     "type": "cell",
                                                     "classes": [
                                                       "divider"
                                                     ],
                                                     "style": {
                                                       "background-color": "#434343",
                                                       "line-height": "10px",
                                                       "border-collapse": "separate",
                                                       "height": "1px"
                                                     }
                                                   }
                                                 ]
                                               }
                                             ]
                                           }
                                         ]
                                       },
                                       {
                                         "type": "text",
                                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tarih:  {{ offerDate }}</span></span></strong></p>\n",
                                         "attributes": {
                                         },
                                         "style": {
                                           "border": "0 none #aaaaaa",
                                           "padding": "3px 10px 0 10px",
                                           "color": "#212121"
                                         }
                                       },
                                       {
                                         "type": "table",
                                         "attributes": {
                                         },
                                         "style": {
                                           "width": "100%",
                                           "margin-top": "10px",
                                           "margin-bottom": "10px"
                                         },
                                         "components": [
                                           {
                                             "type": "tbody",
                                             "components": [
                                               {
                                                 "type": "row",
                                                 "components": [
                                                   {
                                                     "type": "cell",
                                                     "classes": [
                                                       "divider"
                                                     ],
                                                     "style": {
                                                       "background-color": "#434343",
                                                       "line-height": "10px",
                                                       "border-collapse": "separate",
                                                       "height": "1px"
                                                     }
                                                   }
                                                 ]
                                               }
                                             ]
                                           }
                                         ]
                                       },
                                       {
                                         "type": "text",
                                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Son Ge&ccedil;erlilik: {{ offerExpireDate }}</span></span></strong></p>\n",
                                         "attributes": {
                                         },
                                         "style": {
                                           "border": "none #aaaaaa",
                                           "padding": "3px 10px 0 10px",
                                           "color": "#212121"
                                         }
                                       },
                                       {
                                         "type": "table",
                                         "attributes": {
                                         },
                                         "style": {
                                           "width": "100%",
                                           "margin-top": "10px",
                                           "margin-bottom": "10px"
                                         },
                                         "components": [
                                           {
                                             "type": "tbody",
                                             "components": [
                                               {
                                                 "type": "row",
                                                 "components": [
                                                   {
                                                     "type": "cell",
                                                     "classes": [
                                                       "divider"
                                                     ],
                                                     "style": {
                                                       "background-color": "#434343",
                                                       "line-height": "10px",
                                                       "border-collapse": "separate",
                                                       "height": "1px"
                                                     }
                                                   }
                                                 ]
                                               }
                                             ]
                                           }
                                         ]
                                       }
                                     ]
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('bilgilendirme_02', {
       label: 'Yazı Alanı Başlık',
       category: 'Yazı Alanı',
       attributes: {class:'gjs-fonts gjs-c gjs-c-yazi-alani-baslik'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "auto"
         },
         "components": [
           {
             "type": "tbody",
             "attributes": {
             },
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">Yazı Alanı Başlık</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121",
                           "font-size": "12px"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     },
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('address_01', {
       label: 'Adres Alanı - Zemin',
       category: 'Adres Alanı',
       attributes: {class:'gjs-fonts gjs-c gjs-c-adres-alani-zemin'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Fatura Adresi</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#353535",
                           "__": 1,
                           "padding": "3px 10px 3px 10px",
                           "color": "#ffffff"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p>{{ billingAddress }}</p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "2px solid #aaaaaa",
                           "padding": "5px 10px 80px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Vergi Dairesi: {{ taxAdministration }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#f8f8f8",
                           "border": "2px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sevk Adresi</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#353535",
                           "__": 1,
                           "padding": "3px 10px 3px 10px",
                           "color": "#ffffff"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p>{{ shipmentAddress }}</p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "2px solid #aaaaaa",
                           "padding": "5px 10px 80px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Vergi No: {{ taxNo }}</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "background-color": "#f8f8f8",
                           "border": "2px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('address_02', {
       label: 'Adres Alanı - Alt Çizgi',
       category: 'Adres Alanı',
       attributes: {class:'gjs-fonts gjs-c gjs-c-adres-alani-alt-cizgi'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0 10px 0 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">FATURA ADRESİ</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p>{{ billingAddress }}</p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "2px solid #212121",
                           "padding": "5px 10px 80px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">Vergi Dairesi: {{ taxAdministration }}</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0 0 0 10px",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">SEVK ADRESİ</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p>{{ shipmentAddress }}</p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "2px solid #212121",
                           "padding": "5px 10px 80px 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">Vergi No: {{ taxNo }}</span></strong></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#212121"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('bilgilendirme_01', {
       label: 'Yazı Alanı Paragraf',
       category: 'Yazı Alanı',
       attributes: {class:'gjs-fonts gjs-c gjs-c-yazi-alani-paragraf'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong>Sed mollis tempor suscipit,</strong></p>\n\n<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur magna nibh, blandit eu facilisis non, pulvinar sit amet velit. Etiam felis turpis, dictum vitae felis elementum, blandit tincidunt est. Mauris sit amet diam purus. Pellentesque et feugiat urna. Donec dignissim velit massa, in blandit ex dapibus vitae. Proin sed felis malesuada ex consectetur vestibulum. Suspendisse varius enim neque. Ut nec egestas felis. Fusce sapien orci, vestibulum sed bibendum quis, fermentum ac augue. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut arcu pretium turpis molestie finibus vel id arcu.</p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "10px",
                           "font-size": "13px",
                           "font-family": "Arial, Helvetica, sans-serif"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('bilgilendirme_03', {
       label: 'Sayfa Altı Yazı',
       category: 'Yazı Alanı',
       attributes: {class:'gjs-fonts gjs-c gjs-c-sayfa-alti-yazi'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "auto"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "font-size": "12px"
                     },
                     "components": [
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Lorem ipsum Hallkla İlişkiler ve Internet Hizmetleri Ltd. Şti.</strong><br />\nEfeler Mah. 1234 Sk. No:44/A Buca - İzmir<br />\nT: 0232 123 4 567</span></span></p>\n",
                         "attributes": {
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     });

     this.editor.BlockManager.add('product_01', {
       label: 'Ürün Listesi 8 Sütun',
       attributes: {class:'gjs-fonts gjs-c gjs-c-urun-listesi-8-sutun'},
       category: 'Ürün Listesi',
       content: [
         {
           "type": "table",
           "attributes": {
             "width": "100%",
             "height": "150",
           },
           "style": {
             "padding": "5px 20px 5px 20px",
             "margin": "0 auto 10px auto",
             "width": "100%",
             "box-sizing": "border-box",
             "height": "auto"
           },
           "components": [
             {
               "type": "tbody",
               "components": [
                 {
                   "type": "row",
                   "components": [
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "14%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">&Uuml;r&uuml;n Kodu</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 10px 3px 10px",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">&Uuml;r&uuml;n Adı</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 10px 3px 10px",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "12.5%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Birim Fiyatı</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 10px 3px 10px",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Adet</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 10px 3px 10px",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İndirim-%</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 0 3px 0",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">KDV-%</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 10px 3px 10px",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">&Ouml;TV-%</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 10px 3px 10px",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "11%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tutar</span></span></strong></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "background-color": "#e8e8e8",
                             "padding": "3px 10px 3px 10px",
                             "color": "#212121",
                             "text-align": "center"
                           }
                         }
                       ]
                     }
                   ]
                 }, {
                   "type": "comment",
                   "content": "{% for p in products %}",
                   "attributes": {}
                 },{
                   "type": "row",
                   "components": [
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "14%",
                         "font-size": "12px",
                         "box-sizing": "border-box",
                         "border-top" : "none"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.code }}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "font-family": "Arial, Helvetica, sans-serif",
                             "text-align": "center",
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.name }}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "text-align": "left"
                           },
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "12.5%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.price }}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "text-align": "right"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{p.num}}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{p.disc}}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.vat }}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "6.25%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.otv }}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "text-align": "center"
                           }
                         }
                       ]
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "11%",
                         "font-size": "12px",
                         "box-sizing": "border-box"
                       },
                       "components": [
                         {
                           "type": "text",
                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.totalPrice }}</span></span></p>\n",
                           "attributes": {
                           },
                           "style": {
                             "border": "1px solid #aaaaaa",
                             "padding": "3px 10px 3px 10px",
                             "margin": "-2px 0px 0px 0px",
                             "color": "#666666",
                             "font-weight": "400",
                             "text-align": "right"
                           }
                         }
                       ]
                     }
                   ]
                 }, {
                   "type": "text",
                   "content": "<!-- {% endfor %} -->",
                   "attributes": {}
                 }
               ]
             }
           ]
         } ,{
           "type": "table",
           "attributes": {
           },
           "style": {
             "padding": "5px 20px 5px 20px",
             "margin": "0 auto 10px auto",
             "width": "100%",
             "height": "150px"
           },
           "components": [
             {
               "type": "tbody",
               "attributes": {
               },
               "components": [
                 {
                   "type": "row",
                   "attributes": {
                   },
                   "components": [
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "50%",
                         "font-size": "12px"
                       }
                     },
                     {
                       "type": "cell",
                       "attributes": {
                       },
                       "style": {
                         "padding": "0",
                         "margin": "0",
                         "color": "rgb(111, 119, 125)",
                         "font-weight": "300",
                         "vertical-align": "top",
                         "width": "50%",
                         "font-size": "12px"
                       },
                       "components": [
                         {
                           "type": "table",
                           "attributes": {
                           },
                           "style": {
                             "padding": "5px 0 5px 0",
                             "margin": "0 auto 10px auto",
                             "width": "100%",
                             "height": "150px"
                           },
                           "components": [
                             {
                               "type": "tbody",
                               "components": [
                                 {
                                   "type": "row",
                                   "components": [
                                     {
                                       "type": "cell",
                                       "attributes": {
                                       },
                                       "style": {
                                         "padding": "0",
                                         "margin": "0",
                                         "color": "rgb(111, 119, 125)",
                                         "font-weight": "300",
                                         "vertical-align": "top",
                                         "width": "50%",
                                         "font-size": "12px"
                                       },
                                       "components": [
                                         {
                                           "type": "comment",
                                           "content": "{% if showTotalPrice %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam Tutar</span></span></strong></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "background-color": "#e8e8e8",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#212121",
                                             "text-align": "left"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% endif %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% if showTotalDiscount %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam İndirim</span></span></strong></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "background-color": "#e8e8e8",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#212121",
                                             "text-align": "left"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% endif %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Ara Toplam</span></span></strong></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "background-color": "#e8e8e8",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#212121",
                                             "text-align": "left"
                                           }
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam KDV Tutarı</span></span></strong></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "background-color": "#e8e8e8",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#212121",
                                             "text-align": "left"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% if showTotalOtv %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam &Ouml;TV Tutarı</span></span></strong></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "background-color": "#e8e8e8",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#212121",
                                             "text-align": "left"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% endif %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">GENEL TOPLAM</span></span></strong></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "background-color": "#353535",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#ffffff",
                                             "text-align": "left"
                                           }
                                         }
                                       ]
                                     },
                                     {
                                       "type": "cell",
                                       "attributes": {
                                       },
                                       "style": {
                                         "padding": "0",
                                         "margin": "0",
                                         "color": "rgb(111, 119, 125)",
                                         "font-weight": "300",
                                         "vertical-align": "top",
                                         "width": "50%",
                                         "font-size": "12px"
                                       },
                                       "components": [
                                         {
                                           "type": "comment",
                                           "content": "{% if showTotalPrice %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalPrice }}</span></span></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#666666",
                                             "font-weight": "400",
                                             "text-align": "right"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% endif %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% if showTotalDiscount %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalDiscount }}</span></span></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#666666",
                                             "font-weight": "400",
                                             "text-align": "right"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% endif %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ subTotal }}</span></span></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#666666",
                                             "font-weight": "400",
                                             "text-align": "right"
                                           }
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalVat }}</span></span></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#666666",
                                             "font-weight": "400",
                                             "text-align": "right"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% if showTotalOtv %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalOtv }}</span></span></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#666666",
                                             "font-weight": "400",
                                             "text-align": "right"
                                           }
                                         },
                                         {
                                           "type": "comment",
                                           "content": "{% endif %}",
                                           "attributes": {}
                                         },
                                         {
                                           "type": "text",
                                           "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ finalPrice }}</span></strong></span></p>\n",
                                           "attributes": {
                                           },
                                           "style": {
                                             "border": "1px solid #aaaaaa",
                                             "padding": "3px 10px 3px 10px",
                                             "color": "#666666",
                                             "font-weight": "400",
                                             "text-align": "right"
                                           }
                                         }
                                       ]
                                     }
                                   ]
                                 }
                               ]
                             }
                           ]
                         }
                       ]
                     }
                   ]
                 }
               ]
             }
           ]
         }
       ]
     });

     this.editor.BlockManager.add('product_02', {
       label: 'Ürün Listesi 7 Sütun',
       category: 'Ürün Listesi',
       attributes: {class:'gjs-fonts gjs-c gjs-c-urun-listesi-7-sutun'},
       content: [{
         "type": "table",
         "attributes": {
           "width": "100%",
           "height": "150",
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "box-sizing": "border-box",
           "height": "auto"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "14%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">&Uuml;r&uuml;n Kodu</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">&Uuml;r&uuml;n Adı</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "12.5%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Birim Fiyatı</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Adet</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İndirim-%</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">KDV-%</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "11%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Tutar</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "#e8e8e8",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   }
                 ]
               }, {
                 "type": "comment",
                 "content": "{% for p in products %}",
                 "attributes": {}
               }, {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "14%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.code }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "margin": "-2px 0px 0px 0px",
                           "color": "#666666",
                           "font-weight": "400",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.name }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "margin": "-2px 0px 0px 0px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "left"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "12.5%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.price }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "margin": "-2px 0px 0px 0px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "right"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.num }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "margin": "-2px 0px 0px 0px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.disc }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "margin": "-2px 0px 0px 0px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.vat }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "margin": "-2px 0px 0px 0px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "11%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.totalPrice }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "padding": "3px 10px 3px 10px",
                           "margin": "-2px 0px 0px 0px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "right"
                         }
                       }
                     ]
                   }
                 ]
               }, {
                 "type": "comment",
                 "content": "{% endfor %}",
                 "attributes": {}
               }
             ]
           }
         ]
       }, 
                 {
                   "type": "table",
                   "attributes": {
                   },
                   "style": {
                     "padding": "5px 20px 5px 20px",
                     "margin": "0 auto 10px auto",
                     "width": "100%",
                     "height": "150px"
                   },
                   "components": [
                     {
                       "type": "tbody",
                       "attributes": {
                       },
                       "components": [
                         {
                           "type": "row",
                           "attributes": {
                           },
                           "components": [
                             {
                               "type": "cell",
                               "attributes": {
                               },
                               "style": {
                                 "padding": "0",
                                 "margin": "0",
                                 "color": "rgb(111, 119, 125)",
                                 "font-weight": "300",
                                 "vertical-align": "top",
                                 "width": "50%",
                                 "font-size": "12px"
                               }
                             },
                             {
                               "type": "cell",
                               "attributes": {
                               },
                               "style": {
                                 "padding": "0",
                                 "margin": "0",
                                 "color": "rgb(111, 119, 125)",
                                 "font-weight": "300",
                                 "vertical-align": "top",
                                 "width": "50%",
                                 "font-size": "12px"
                               },
                               "components": [
                                 {
                                   "type": "table",
                                   "attributes": {
                                   },
                                   "style": {
                                     "padding": "5px 0 5px 0",
                                     "margin": "0 auto 10px auto",
                                     "width": "100%",
                                     "height": "150px"
                                   },
                                   "components": [
                                     {
                                       "type": "tbody",
                                       "components": [
                                         {
                                           "type": "row",
                                           "components": [
                                             {
                                               "type": "cell",
                                               "attributes": {
                                               },
                                               "style": {
                                                 "padding": "0",
                                                 "margin": "0",
                                                 "color": "rgb(111, 119, 125)",
                                                 "font-weight": "300",
                                                 "vertical-align": "top",
                                                 "width": "50%",
                                                 "font-size": "12px"
                                               },
                                               "components": [
                                                 {
                                                   "type": "comment",
                                                   "content": "{% if showTotalPrice %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam Tutar</span></span></strong></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "background-color": "#e8e8e8",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#212121",
                                                     "text-align": "left"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% endif %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% if showTotalDiscount %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam İndirim</span></span></strong></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "background-color": "#e8e8e8",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#212121",
                                                     "text-align": "left"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% endif %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Ara Toplam</span></span></strong></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "background-color": "#e8e8e8",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#212121",
                                                     "text-align": "left"
                                                   }
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam KDV Tutarı</span></span></strong></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "background-color": "#e8e8e8",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#212121",
                                                     "text-align": "left"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% if showTotalOtv %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam &Ouml;TV Tutarı</span></span></strong></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "background-color": "#e8e8e8",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#212121",
                                                     "text-align": "left"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% endif %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">GENEL TOPLAM</span></span></strong></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "background-color": "#353535",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#ffffff",
                                                     "text-align": "left"
                                                   }
                                                 }
                                               ]
                                             },
                                             {
                                               "type": "cell",
                                               "attributes": {
                                               },
                                               "style": {
                                                 "padding": "0",
                                                 "margin": "0",
                                                 "color": "rgb(111, 119, 125)",
                                                 "font-weight": "300",
                                                 "vertical-align": "top",
                                                 "width": "50%",
                                                 "font-size": "12px"
                                               },
                                               "components": [
                                                 {
                                                   "type": "comment",
                                                   "content": "{% if showTotalPrice %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalPrice }}</span></span></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#666666",
                                                     "font-weight": "400",
                                                     "text-align": "right"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% endif %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% if showTotalDiscount  %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalDiscount }}</span></span></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#666666",
                                                     "font-weight": "400",
                                                     "text-align": "right"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% endif %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ subTotal }}</span></span></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#666666",
                                                     "font-weight": "400",
                                                     "text-align": "right"
                                                   }
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalVat }}</span></span></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#666666",
                                                     "font-weight": "400",
                                                     "text-align": "right"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% if showTotalOtv %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalOtv }}</span></span></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#666666",
                                                     "font-weight": "400",
                                                     "text-align": "right"
                                                   }
                                                 },
                                                 {
                                                   "type": "comment",
                                                   "content": "{% endif %}",
                                                   "attributes": {}
                                                 },
                                                 {
                                                   "type": "text",
                                                   "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ finalPrice }}</span></strong></span></p>\n",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "border": "1px solid #aaaaaa",
                                                     "padding": "3px 10px 3px 10px",
                                                     "color": "#666666",
                                                     "font-weight": "400",
                                                     "text-align": "right"
                                                   }
                                                 }
                                               ]
                                             }
                                           ]
                                         }
                                       ]
                                     }
                                   ]
                                 }
                               ]
                             }
                           ]
                         }
                       ]
                     }
                   ]
       }]
     });

     this.editor.BlockManager.add('product_03', {
       label: 'Ürün Listesi - Alt Çizgi',
       category: 'Ürün Listesi',
       attributes: {class:'gjs-fonts gjs-c gjs-c-urun-listesi-alt-cizgi'},
       content: [    {
         "type": "table",
         "attributes": {
           "width": "100%",
           "height": "150",
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "box-sizing": "border-box",
           "height": "auto"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "14%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">&Uuml;r&uuml;n Kodu</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "none",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">&Uuml;r&uuml;n Adı</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "none",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "12.5%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Birim Fiyatı</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "none",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row"
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Adet</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "none",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">İndirim-%</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "none",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">KDV-%</span></span></strong></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px solid #aaaaaa",
                           "background-color": "none",
                           "padding": "3px 10px 3px 10px",
                           "color": "#212121",
                           "text-align": "center"
                         }
                       }
                     ]
                   }
                 ]
               }, {
                 "type": "comment",
                 "content": "{% for p in products %}",
                 "attributes": {}
               }, {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "14%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.code }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#666666",
                           "font-weight": "400",
                           "font-family": "Arial, Helvetica, sans-serif",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "attributes": {
                                     },
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.name }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "attributes": {
                                     },
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "12.5%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.price }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "right"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "attributes": {
                                     },
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.num }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "margin": "0 0 0 0",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "attributes": {
                                     },
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.disc }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "attributes": {
                                     },
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "6.25%",
                       "font-size": "12px",
                       "box-sizing": "border-box"
                     },
                     "components": [
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ p.vat }}</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "border": "1px none #aaaaaa",
                           "padding": "3px 10px 0 10px",
                           "color": "#666666",
                           "font-weight": "400",
                           "text-align": "center"
                         }
                       },
                       {
                         "type": "table",
                         "attributes": {
                         },
                         "style": {
                           "width": "100%",
                           "margin-top": "10px",
                           "margin-bottom": "10px"
                         },
                         "components": [
                           {
                             "type": "tbody",
                             "components": [
                               {
                                 "type": "row",
                                 "components": [
                                   {
                                     "type": "cell",
                                     "classes": [
                                       "divider"
                                     ],
                                     "attributes": {
                                     },
                                     "style": {
                                       "background-color": "#434343",
                                       "line-height": "10px",
                                       "border-collapse": "separate",
                                       "height": "1px"
                                     }
                                   }
                                 ]
                               }
                             ]
                           }
                         ]
                       }
                     ]
                   }
                 ]
               }, {
                 "type": "comment",
                 "content": "{% endfor %}",
                 "attributes": {}
               }
             ]
           }
         ]
       },
                     {
                       "type": "table",
                       "attributes": {
                       },
                       "style": {
                         "padding": "5px 20px 5px 20px",
                         "margin": "0 auto 10px auto",
                         "width": "100%",
                         "height": "150px"
                       },
                       "components": [
                         {
                           "type": "tbody",
                           "attributes": {
                           },
                           "components": [
                             {
                               "type": "row",
                               "attributes": {
                               },
                               "components": [
                                 {
                                   "type": "cell",
                                   "attributes": {
                                   },
                                   "style": {
                                     "padding": "0",
                                     "margin": "0",
                                     "color": "rgb(111, 119, 125)",
                                     "font-weight": "300",
                                     "vertical-align": "top",
                                     "width": "50%",
                                     "font-size": "12px"
                                   }
                                 },
                                 {
                                   "type": "cell",
                                   "attributes": {
                                   },
                                   "style": {
                                     "padding": "0",
                                     "margin": "0",
                                     "color": "rgb(111, 119, 125)",
                                     "font-weight": "300",
                                     "vertical-align": "top",
                                     "width": "50%",
                                     "font-size": "12px"
                                   },
                                   "components": [
                                     {
                                       "type": "table",
                                       "attributes": {
                                       },
                                       "style": {
                                         "padding": "5px 0 5px 0",
                                         "margin": "0 auto 10px auto",
                                         "width": "100%",
                                         "height": "150px"
                                       },
                                       "components": [
                                         {
                                           "type": "tbody",
                                           "components": [
                                             {
                                               "type": "row",
                                               "components": [
                                                 {
                                                   "type": "cell",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "padding": "0",
                                                     "margin": "0",
                                                     "color": "rgb(111, 119, 125)",
                                                     "font-weight": "300",
                                                     "vertical-align": "top",
                                                     "width": "50%",
                                                     "font-size": "12px"
                                                   },
                                                   "components": [
                                                     {
                                                       "type": "comment",
                                                       "content": "{% if showTotalPrice %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam Tutar</span></span></strong></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#212121",
                                                         "text-align": "left"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% endif %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% if showTotalDiscount %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam İndirim</span></span></strong></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#212121",
                                                         "text-align": "left"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% endif %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Ara Toplam</span></span></strong></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#212121",
                                                         "text-align": "left"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam KDV Tutarı</span></span></strong></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#212121",
                                                         "text-align": "left"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% if showTotalOtv %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><strong><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Toplam &Ouml;TV Tutarı</span></span></strong></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#212121",
                                                         "text-align": "left"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% endif %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><span style=\"font-size:16px;\"><strong><span style=\"font-family:Arial,Helvetica,sans-serif;\">GENEL TOPLAM</span></strong></span></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "background-color": "none",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#212121",
                                                         "text-align": "left"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     }
                                                   ]
                                                 },
                                                 {
                                                   "type": "cell",
                                                   "attributes": {
                                                   },
                                                   "style": {
                                                     "padding": "0",
                                                     "margin": "0",
                                                     "color": "rgb(111, 119, 125)",
                                                     "font-weight": "300",
                                                     "vertical-align": "top",
                                                     "width": "50%",
                                                     "font-size": "12px"
                                                   },
                                                   "components": [
                                                     {
                                                       "type": "comment",
                                                       "content": "{% if showTotalPrice %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalPrice }}</span></span></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#666666",
                                                         "font-weight": "400",
                                                         "text-align": "right"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% endif %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% if showTotalDiscount %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalDiscount }}</span></span></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#666666",
                                                         "font-weight": "400",
                                                         "text-align": "right"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% endif %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ subTotal }}</span></span></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#666666",
                                                         "font-weight": "400",
                                                         "text-align": "right"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalVat }}</span></span></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#666666",
                                                         "font-weight": "400",
                                                         "text-align": "right"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% if showTotalOtv %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">{{ totalOtv }}</span></span></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#666666",
                                                         "font-weight": "400",
                                                         "text-align": "right"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     },
                                                     {
                                                       "type": "comment",
                                                       "content": "{% endif %}",
                                                       "attributes": {}
                                                     },
                                                     {
                                                       "type": "text",
                                                       "content": "<p><font face=\"Arial, Helvetica, sans-serif\"><span style=\"font-size: 16px;\"><b>{{ finalPrice }}</b></span></font></p>\n",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "border": "1px none #aaaaaa",
                                                         "background-color": "none",
                                                         "padding": "3px 10px 0 10px",
                                                         "color": "#212121",
                                                         "text-align": "right"
                                                       }
                                                     },
                                                     {
                                                       "type": "table",
                                                       "attributes": {
                                                       },
                                                       "style": {
                                                         "width": "100%",
                                                         "margin-top": "10px",
                                                         "margin-bottom": "10px"
                                                       },
                                                       "components": [
                                                         {
                                                           "type": "tbody",
                                                           "components": [
                                                             {
                                                               "type": "row",
                                                               "components": [
                                                                 {
                                                                   "type": "cell",
                                                                   "classes": [
                                                                     "divider"
                                                                   ],
                                                                   "style": {
                                                                     "background-color": "#434343",
                                                                     "line-height": "10px",
                                                                     "border-collapse": "separate",
                                                                     "height": "1px"
                                                                   }
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     }
                                                   ]
                                                 }
                                               ]
                                             }
                                           ]
                                         }
                                       ]
                                     }
                                   ]
                                 }
                               ]
                             }
                           ]
                         }
                       ]
       }]
     });

     this.editor.BlockManager.add('image_01', {
       label: 'Tek Görsel',
       category: 'Görseller',
       attributes: {class:'gjs-fonts gjs-c gjs-c-tek-gorsel'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "height": "150px",
           "margin": "0 auto 10px auto",
           "padding": "5px 5px 5px 5px",
           "width": "100%"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "0",
                       "width": "20%"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "60%",
                       "text-align": "center",
                       "border": "1px solid #aaaaaa"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/295747840a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "0",
                       "width": "20%"
                     }
                   }
                 ]
               }
             ]
           }
         ]
       }
     })

     this.editor.BlockManager.add('image_02', {
       label: 'Tek Görsel - Zeminli',
       category: 'Görseller',
       attributes: {class:'gjs-fonts gjs-c gjs-c-tek-gorsel-zeminli'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "height": "150px",
           "margin": "0 auto 10px auto",
           "padding": "5px 5px 5px 5px",
           "width": "100%"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "0",
                       "width": "20%"
                     }
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "60%",
                       "text-align": "center",
                       "border": "1px none #aaaaaa",
                       "background-color": "#f8f8f8"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/295747840a2511eca6ee0242c0a81002.jpeg"
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "0",
                       "width": "20%"
                     }
                   }
                 ]
               }
             ]
           }
         ]
       }
     })

     this.editor.BlockManager.add('image_03', {
       label: '2 Sütün Görsel - 01',
       category: 'Görseller',
       attributes: {class:'gjs-fonts gjs-c gjs-c-2-sutun-gorsel-01'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 0 20px 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px",
                       "text-align": "center",
                       "border": "1px solid #aaaaaa"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 0 20px 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px",
                       "text-align": "center",
                       "border": "1px solid #aaaaaa"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     })

     this.editor.BlockManager.add('image_04', {
       label: '2 Sütün Görsel - 02',
       category: 'Görseller',
       attributes: {class:'gjs-fonts gjs-c gjs-c-2-sutun-gorsel-02'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "padding": "5px 20px 5px 20px",
           "margin": "0 auto 10px auto",
           "width": "100%",
           "height": "150px"
         },
         "components": [
           {
             "type": "tbody",
             "attributes": {
             },
             "components": [
               {
                 "type": "row",
                 "attributes": {
                 },
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 0 20px 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px",
                       "text-align": "center",
                       "border": "1px none #aaaaaa",
                       "background-color": "#f8f8f8"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "padding": "20px 0 20px 0",
                       "margin": "0",
                       "color": "rgb(111, 119, 125)",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "width": "50%",
                       "font-size": "12px",
                       "text-align": "center",
                       "border": "1px none #aaaaaa",
                       "background-color": "#e8e8e8"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     })

     this.editor.BlockManager.add('image_05', {
       label: '3 Sütün Görsel - 01',
       category: 'Görseller',
       attributes: {class:'gjs-fonts gjs-c gjs-c-3-sutun-gorsel-01'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "height": "150px",
           "margin": "0 auto 10px auto",
           "padding": "5px 20px 5px 20px",
           "width": "100%"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "33.3333%",
                       "text-align": "center",
                       "border": "1px solid #aaaaaa"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "padding": "0 0 0 0"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "33.3333%",
                       "text-align": "center",
                       "border": "1px solid #aaaaaa"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "33.3333%",
                       "text-align": "center",
                       "border": "1px solid #aaaaaa"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     })

     this.editor.BlockManager.add('image_06', {
       label: '3 Sütün Görsel - 02',
       category: 'Görseller',
       attributes: {class:'gjs-fonts gjs-c gjs-c-3-sutun-gorsel-02'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "height": "150px",
           "margin": "0 auto 10px auto",
           "padding": "5px 20px 5px 20px",
           "width": "100%"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "33.3333%",
                       "text-align": "center",
                       "border": "1px none #aaaaaa",
                       "background-color": "#f8f8f8"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black",
                           "padding": "0 0 0 0"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "33.3333%",
                       "text-align": "center",
                       "border": "1px none #aaaaaa",
                       "background-color": "#e8e8e8"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg",
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   },
                   {
                     "type": "cell",
                     "attributes": {
                     },
                     "style": {
                       "font-size": "12px",
                       "font-weight": "300",
                       "vertical-align": "top",
                       "color": "rgb(111, 119, 125)",
                       "margin": "0",
                       "padding": "20px 0 20px 0",
                       "width": "33.3333%",
                       "text-align": "center",
                       "border": "1px none #aaaaaa",
                       "background-color": "#f8f8f8"
                     },
                     "components": [
                       {
                         "type": "image",
                         "attributes": {
                           "src": "https://daily-mail.fra1.digitaloceanspaces.com/2021/08/31/950764460a2511eca6ee0242c0a81002.jpeg"
                         },
                         "style": {
                           "color": "black"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:16px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\"><strong>Başlık metni burada yer alacak</strong></span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "5px 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left"
                         }
                       },
                       {
                         "type": "text",
                         "content": "<p><span style=\"font-size:14px;\"><span style=\"font-family:Arial,Helvetica,sans-serif;\">Sed eget libero consectetur elit sagittis ornare. Etiam vulputate, leo nec tempus fringilla, purus libero lacinia nulla, et rutrum ex tortor id neque. Praesent in neque sit amet dui commodo elementum a id nulla. Donec tincidunt vitae dui in mattis. Duis nec nibh ut diam aliquam mattis quis ut mi.&nbsp;</span></span></p>\n",
                         "attributes": {
                         },
                         "style": {
                           "padding": "0 20px 0 20px",
                           "color": "#212121",
                           "text-align": "left",
                           "line-height": "18px"
                         }
                       }
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     })

     this.editor.BlockManager.add('page_break_01', {
       label: 'Page Break',
       category: 'Default',
       attributes: {class:'gjs-fonts gjs-f-divider'},
       content: {
         "type": "table",
         "attributes": {
         },
         "style": {
           "width": "100%",
           "margin-top": "10px",
           "margin-bottom": "10px",
           "page-break-before": "always"
         },
         "components": [
           {
             "type": "tbody",
             "components": [
               {
                 "type": "row",
                 "components": [
                   {
                     "type": "cell",
                     "classes": [
                       "divider"
                     ]
                   }
                 ]
               }
             ]
           }
         ]
       }
     })

     this.editor.Panels.addButton('options', [{
       id: 'undo',
       className: 'fa fa-undo',
       attributes: {title: 'Undo'},
       command: function( editor ){ editor.runCommand('core:undo') }
     },{
       id: 'redo',
       className: 'fa fa-redo',
       attributes: {title: 'Redo'},
       command: function( editor ){ editor.runCommand('core:redo') }
     },{
       id: 'clear-all',
       className: 'fa fa-trash',
       attributes: {title: 'Clear canvas'},
       command: {
         run: function(editor, sender) {
           sender && sender.set('active', false);
           if(confirm('Are you sure to clean the canvas?')){
             editor.DomComponents.clear();
             setTimeout(function(){
               localStorage.clear()
             },0)
           }
         }
       }
     },{
       id: 'preview',
       context: 'preview',
       command: e => e.runCommand('preview'),
       className: 'fa fa-eye',
     }]);

     /* this.editor.Panels.addButton('devices-c', [{
      *   id: 'tabletPdf',
      *   command: 'set-device-tablet-pdf',
      *   className: 'fa fa-tablet',
      *   // attributes: {[tltAttr]: opt.cmdBtnDesktopLabel},
      *   active: 1,
      * }]); */

     // Beautify tooltips
     var titles = document.querySelectorAll('*[title]');
     for (var i = 0; i < titles.length; i++) {
       var el = titles[i];
       var title = el.getAttribute('title');
       title = title ? title.trim(): '';
       if(!title)
         break;
       el.setAttribute('data-tooltip', title);
       el.setAttribute('title', '');
     }


     this.editor.Commands.add('saveCmd', {
       run(editor) {
         (function($) {
           $("#saveEmailTemplateModal").modal('show')
         }(jQuery));
       }
     });

     this.editor.Commands.add('pdfCmd', {
       run(editor) {
         (function($) {
           $("#createPdf").click()
         }(jQuery));
       }
     });

     this.editor.Commands.add('set-device-tablet-pdf', {
       run(editor) {
         editor.setDevice('PDF');
       }
     });
     this.editor.Commands.run('set-device-tablet-pdf', { });
     this.editor.Panels.removeButton('devices-c', 'deviceTablet');
     this.editor.Panels.removeButton('devices-c', 'deviceMobile');
     this.editor.Panels.removeButton('devices-c', 'deviceDesktop');

     this.getEmailTemplate()
 }
 }
</script>

<style>
 .gjs-c {
   background-repeat: no-repeat;
   background-position: 50% 30%;
 }
 .gjs-c::before{content:" ";}

 .gjs-c-adres-alani-zemin {
   background-image: url("/static/images/email-editor/01-adres-alani.png");
 }

 .gjs-c-adres-alani-alt-cizgi {
   background-image: url("/static/images/email-editor/02-adres-alani.png");
 }

 .gjs-c-logo-sagda-adres {
   background-image: url("/static/images/email-editor/01-logo-alani-logo-a.png");
 }

 .gjs-c-logo-sagda-adres-2 {
   background-image: url("/static/images/email-editor/02-logo-alani-logo-b.png");
 }

 .gjs-c-logo-sagda-baslik {
   background-image: url("/static/images/email-editor/03-logo-baslik.png");
 }

 .gjs-c-solda-baslik-logo {
   background-image: url("/static/images/email-editor/04-baslik-logo.png");
 }

 .gjs-c-logo-alani-adres {
   background-image: url("/static/images/email-editor/05-logo-alani-c.png");
 }

 .gjs-c-logo-alani-adres-2 {
   background-image: url("/static/images/email-editor/06-logo-alani-d.png");
 }

 .gjs-c-ortada-logo-adres {
   background-image: url("/static/images/email-editor/07-logo-alani-e.png");
 }

 .gjs-c-ortada-logo-adres-2 {
   background-image: url("/static/images/email-editor/08-logo-alani-f.png");
 }

 .gjs-c-solda-sirket-bilgileri {
   background-image: url("/static/images/email-editor/09-solda-sirket-bilgisi.png");
 }

 .gjs-c-ortada-sirket-bilgileri {
   background-image: url("/static/images/email-editor/10-ortada-sirket-bilgisi.png");
 }

 .gjs-c-teklif-baslik-01 {
   background-image: url("/static/images/email-editor/01-teklif-baslik.png");
 }

 .gjs-c-teklif-baslik-02 {
   background-image: url("/static/images/email-editor/02-teklif-baslik.png");
 }

 .gjs-c-teklif-baslik-03 {
   background-image: url("/static/images/email-editor/03-teklif-baslik.png");
 }

 .gjs-c-imza-alani-zemin {
   background-image: url("/static/images/email-editor/01-imza-alani.png");
 }

 .gjs-c-imza-alani-alt-cizgi {
   background-image: url("/static/images/email-editor/02-imza-alani.png");
 }

 .gjs-c-firma-bilgileri-zemin {
   background-image: url("/static/images/email-editor/01-firma-bilgileri.png");
 }

 .gjs-c-firma-bilgileri-alt-cizgi {
   background-image: url("/static/images/email-editor/02-firma-bilgileri.png");
 }

 .gjs-c-yazi-alani-baslik {
   background-image: url("/static/images/email-editor/01-yazi-alani.png");
 }

 .gjs-c-yazi-alani-paragraf {
   background-image: url("/static/images/email-editor/03-yazi-alani.png");
 }

 .gjs-c-sayfa-alti-yazi {
   background-image: url("/static/images/email-editor/03-yazi-alani.png");
 }

 .gjs-c-urun-listesi-8-sutun {
   background-image: url("/static/images/email-editor/01-urun-listesi.png");
 }

 .gjs-c-urun-listesi-7-sutun {
   background-image: url("/static/images/email-editor/02-urun-listesi.png");
 }

 .gjs-c-urun-listesi-alt-cizgi {
   background-image: url("/static/images/email-editor/03-urun-listesi.png");
 }

 .gjs-c-tek-gorsel {
   background-image: url("/static/images/email-editor/01-gorsel.png");
 }

 .gjs-c-tek-gorsel-zeminli {
   background-image: url("/static/images/email-editor/02-gorsel.png");
 }

 .gjs-c-2-sutun-gorsel-01 {
   background-image: url("/static/images/email-editor/03-gorsel.png");
 }

 .gjs-c-2-sutun-gorsel-02 {
   background-image: url("/static/images/email-editor/04-gorsel.png");
 }

 .gjs-c-3-sutun-gorsel-01 {
   background-image: url("/static/images/email-editor/05-gorsel.png");
 }

 .gjs-c-3-sutun-gorsel-02 {
   background-image: url("/static/images/email-editor/06-gorsel.png");
 }

</style>
